import { z } from 'zod';
export const calEventChecklistItemSchema = z
    .string()
    .trim()
    .min(1, 'Checklist item cannot be blank.')
    .max(512, 'Checklist item must be 512 characters or fewer.');
//# sourceMappingURL=cal-event-checklist-item-schema.js.map